// extracted by mini-css-extract-plugin
module.exports = {"holder":"file-upload_holder__3JV16","dragging":"file-upload_dragging__2LgBJ","disabled":"file-upload_disabled__2sERg","content":"file-upload_content__2jh0C"};